import React from 'react'
import './Integrations.css'

function Integrations() {
  const ides = [
    {
      name: 'Cursor',
      description: 'AI-first code editor',
      logo: '⚡'
    },
    {
      name: 'VS Code',
      description: 'Most popular editor',
      logo: '📝'
    },
    {
      name: 'Windsurf',
      description: 'Codeium-powered IDE',
      logo: '🌊'
    }
  ]

  return (
    <section id="integrations" className="integrations">
      <div className="container">
        <div className="integrations-header">
          <h2 className="integrations-title">
            Works with your <span className="gradient-text">favorite tools</span>
          </h2>
          <p className="integrations-subtitle">
            Seamless integration with the most popular AI-powered development environments
          </p>
        </div>
        <div className="ide-grid">
          {ides.map((ide, index) => (
            <div
              key={index}
              className="ide-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="ide-logo">{ide.logo}</div>
              <h3 className="ide-name">{ide.name}</h3>
              <p className="ide-description">{ide.description}</p>
            </div>
          ))}
        </div>
        <div className="integrations-note">
          <p>
            More integrations coming soon. Want to see your IDE supported?{' '}
            <a href="https://github.com/vibecodingmachine" target="_blank" rel="noopener noreferrer">
              Let us know
            </a>
          </p>
        </div>
      </div>
    </section>
  )
}

export default Integrations
